import HomeIcon from '@mui/icons-material/Home';
import TimelineIcon from '@mui/icons-material/Timeline';
import HistoryIcon from '@mui/icons-material/History';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { addActiveClass, customStyles } from '../styles';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
export const navbarRoutes = [
   {
      title: 'Inicio',
      route: '/dashboard/content',
      component: <HomeIcon sx={{color: customStyles.colors.main, cursor: 'pointer', ...addActiveClass}}/>,
   },
   {
      title: 'Mis Direcciones',
      route: '/dashboard/accounts',
      component: <FmdGoodIcon sx={{color: customStyles.colors.main, cursor: 'pointer', ...addActiveClass}}/>,
   },
   {
      title: 'Historial',
      route: '/dashboard/history',
      component: <HistoryIcon sx={{color: customStyles.colors.main, cursor: 'pointer', ...addActiveClass}}/>,
   },
   // {
   //    title: 'Soporte',
   //    route: '/dashboard/soporte',
   //    component: <HelpOutlineIcon sx={{color: customStyles.colors.main, cursor: 'pointer', ...addActiveClass}}/>,
   //    subMenu: true
   // },
]